/* eslint-disable dot-notation */
import React from 'react';
import { Suripanta } from '../suripanta';
export const RedirectHeaderMeta = ({ url, contentCode = '301' }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Suripanta, { key: "redirect_metaA", parent: "head", location: "start", type: "meta", attributes: [
                {
                    name: 'name',
                    value: 'prerender-header',
                },
                {
                    name: 'content',
                    value: `Location: ${window['SEO_PROTOCOL'] ? window['SEO_PROTOCOL'] : window.location.protocol}//${window['SEO_HOST'] || window.location.host}${url}`,
                },
            ], lazyLoad: false }),
        React.createElement(Suripanta, { key: "redirect_metaB", parent: "head", location: "start", type: "meta", attributes: [{ name: 'name', value: 'prerender-status-code' }, { name: 'content', value: contentCode }], lazyLoad: false })));
};
